export default new class {

  /**
   *
   * @param value
   * @return {boolean}
   */
  isNumeric (value) {
    return !isNaN(parseFloat(value)) && isFinite(value)
  }

}